import { TipoDocumento } from "../tipo/tipo-documento.class";
import { TipoActividad } from "../tipo/tipo-actividad.class";
import { DireccionCliente } from "./direccion-cliente.class";

export class RegistroCliente {
  tipoIdentificacion: String;
  numeroIdentificacion: String;
  nombre1: String;
  nombre2: String;
  apellido1: String;
  apellido2: String;
  sexo: String;
  fechaNacimiento: Date;
  celular: String;
  tipoPersona: String;
  ocupacion: String;
  descripcionOcupacion: String;
  correspondenciaSeleccionada: String;
  direcciones: { [nombre: string]: DireccionCliente };


  dniAsesor: String;
    paisOrigen: String;
    fechaExpedicion: Date;

  constructor() {
    this.tipoIdentificacion = null;
    this.numeroIdentificacion = "";
    this.nombre1 = "";
    this.nombre2 = "";
    this.apellido1 = "";
    this.apellido2 = "";
    this.sexo = "";
    this.fechaNacimiento = null;
    this.celular = "";
    this.tipoPersona = null;
    this.ocupacion = null;
    this.descripcionOcupacion = null;
    this.correspondenciaSeleccionada = "";
    this.direcciones = {};
    this.dniAsesor = "";
  }
}



// WEBPACK FOOTER //
// ./src/app/models/cliente/registro-cliente.class.ts